module.exports = __webpack_public_path__ + "3cd35dbbce2b980d5f1634286770014a.pdf";